module.exports = __webpack_public_path__ + "img/used0.cbc9dfdc.webp";